/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import React, { useState } from 'react';
import {
  type Customer,
} from '../store/customerTypes';
import { Table, Modal } from 'antd';
import PlusFilledWhite from '../../../assets/icons/plus-filled-white.svg';
/* eslint-disable @typescript-eslint/no-unused-vars */
import SaleModal from '../SaleModal';
import CloseModal from '../CloseModal';
import LoanPrintableContent from '../../Loan/PrintableContent';

interface Sale {
  _id: string;
  saleNumber: string;
  customer: any;
  principal: number;
  onlinePrincipal?: number;
  offlinePrincipal?: number;
  documentCharge: number;
  status: string;
  photo: string;
  startDate: string;
  branch: any;
  metal: string;
  jewels: any[];
  remarks: string;
  createdDate: string;
  remainingPrincipal: number;
  transactions: any[];
  [key: string]: any;
}

interface SaleDetails {
  activeSale: Sale[] | undefined;
  closedSale: Sale[] | undefined;
  cashPending: Sale[] | undefined;
  approvals: Sale[] | undefined;
  rejected: Sale[] | undefined;
}

interface Props {
  sales?: SaleDetails;
  customer?: Customer;
  refetchCustomer: (customerId: string) => void;
}

export default function SaleDetailsIndex({
  sales,
  customer,
  refetchCustomer,
}: Props): JSX.Element {
  const [selectedSale, setSelectedSale] = useState<Sale>();
  const [selectedSaleTransactions, setSelectedSaleTransactions] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);
  const [printSelectedSale, setPrintSelectedSale] = useState<Sale>();
  const [isSalePrintModalOpen, setIsSalePrintModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const showCloseModal = () => {
    setIsCloseModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedSale(undefined);
    setSelectedSaleTransactions(undefined);
  };

  const handleCloseModalClose = () => {
    setIsCloseModalOpen(false);
    setSelectedSale(undefined);
  };

  const nonActiveSaleColumns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      render: (_: any, record: Sale, index: number) => index + 1,
      width: 50,
    },
    {
      title: 'Sale No.',
      dataIndex: 'saleNumber',
      width: 46,
      render: (_: any, record: Sale) => (
        <p className="closed__loan__data">{record.saleNumber}</p>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'actions',
      width: 120,
      render: (_: any, record: Sale) => (
        <p
          style={{
            color: '#DD1E2D',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={async () => {
            setSelectedSale(record);
            setSelectedSaleTransactions(record.transactions);
            showModal();
          }}
        >
          View Details
        </p>
      ),
    },
  ];

  const closedSaleColumns = [
    {
      title: 'S.No',
      dataIndex: 'sno',
      render: (_: any, record: Sale, index: number) => index + 1,
      width: 50,
    },
    {
      title: 'Sale No.',
      dataIndex: 'saleNumber',
      width: 46,
      render: (_: any, record: Sale) => (
        <p className="closed__loan__data">{record.saleNumber}</p>
      ),
    },
    {
      title: 'Pledge No.',
      dataIndex: 'pledgeNumber',
      width: 46,
      render: (_: any, record: Sale) => {
        const pledgeNumbers = new Set(
          record?.jewels
            .filter((jewel: any) => jewel.isPledged)
            .map((jewel: any) => jewel.pledgeNumber)
        );
        return (
          <p className="closed__loan__data">
            {Array.from(pledgeNumbers).map((x) => (
              <p className="data" style={{ margin: 0 }} key={x}>
                {x}
              </p>
            ))}
          </p>
        );
      },
    },
    {
      title: 'Status',
      dataIndex: 'actions',
      width: 120,
      render: (_: any, record: Sale) => (
        <p
          style={{
            color: '#DD1E2D',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={async () => {
            setSelectedSale(record);
            setSelectedSaleTransactions(record.transactions);
            showModal();
          }}
        >
          View Details
        </p>
      ),
    },
    {
      title: 'Print',
      dataIndex: 'print',
      width: 120,
      render: (_: any, record: Sale) => (
        <p
          style={{
            width: 73,
            height: 34,
            borderRadius: 12,
            backgroundColor: '#DD1E2D',
            color: 'white',
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={() => {
            setPrintSelectedSale(record);
            setIsSalePrintModalOpen(true);
          }}
        >
          Print
        </p>
      ),
    },
  ];

  const activeSaleColumns = [
    ...closedSaleColumns,
    {
      title: 'Close',
      dataIndex: 'close',
      width: 120,
      render: (_: any, record: Sale) => (
        <p
          style={{
            width: 73,
            height: 34,
            borderRadius: 12,
            backgroundColor: '#DD1E2D',
            color: 'white',
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={() => {
            setSelectedSale(record);
            showCloseModal();
          }}
        >
          Close
        </p>
      ),
    },
  ];

  return (
    <div className="loan__details__page">
      <div className="closed__loan__section">
        <div className="current__loan__header">
          <p className="closed__loan__title">Current Sales</p>
          <a
            className="create__loan__button"
            href={`/sales?customerId=${customer?.customerId}`}
          >
            <img className="plus__icon" src={PlusFilledWhite} /> Create Sale
          </a>
        </div>

        <Table
          dataSource={sales?.activeSale}
          columns={activeSaleColumns}
          pagination={false}
          rowKey={(record: Sale) => record.saleNumber.toString()}
        />
      </div>

      <div className="closed__loan__section">
        <p className="closed__loan__title">Closed Sales</p>
        <Table
          dataSource={sales?.closedSale}
          columns={closedSaleColumns}
          pagination={false}
          rowKey={(record: Sale) => record.saleNumber.toString()}
        />
      </div>

      <div className="closed__loan__section">
        <div className="current__loan__header">
          <p className="closed__loan__title">Cash disbursement pending</p>
        </div>

        <Table
          dataSource={sales?.cashPending}
          columns={closedSaleColumns}
          pagination={false}
          rowKey={(record: Sale) => record.saleNumber.toString()}
        />
      </div>

      <div className="closed__loan__section">
        <div className="current__loan__header">
          <p className="closed__loan__title">Sale Approvals Pending</p>
        </div>

        <Table
          dataSource={sales?.approvals}
          columns={nonActiveSaleColumns}
          pagination={false}
          rowKey={(record: Sale) => record.saleNumber.toString()}
        />
      </div>

      <div className="closed__loan__section">
        <div className="current__loan__header">
          <p className="closed__loan__title">Sales Rejected</p>
        </div>

        <Table
          dataSource={sales?.rejected}
          columns={nonActiveSaleColumns}
          pagination={false}
          rowKey={(record: Sale) => record.saleNumber.toString()}
        />
      </div>

      <Modal
        width={1129}
        title="Sale Details"
        open={isModalOpen}
        onCancel={handleClose}
        footer={() => <></>}
      >
        {selectedSale !== undefined && (
          <SaleModal
            openPrintModal={(transaction: any) => {}}
            transactions={selectedSaleTransactions ?? []}
            customer={customer}
            saleDetail={selectedSale as any}
          />
        )}
      </Modal>

      <Modal
        width={1020}
        title={
          <div style={{ display: 'flex', flexDirection: 'row', gap: 24 }}>
            <span>Sale summary</span>
          </div>
        }
        open={isSalePrintModalOpen}
        onCancel={() => {
          setIsSalePrintModalOpen(false);
          setPrintSelectedSale(undefined);
        }}
        footer={() => <></>}
      >
        {printSelectedSale !== undefined && customer !== undefined && (
          <LoanPrintableContent
            loanDetails={printSelectedSale}
            customer={customer}
            type="sale"
          />
        )}
      </Modal>

      <Modal
        width={900}
        title="Close Sale"
        open={isCloseModalOpen}
        onCancel={handleCloseModalClose}
        footer={() => <></>}
      >
        {selectedSale !== undefined && (
          <CloseModal
            sale={selectedSale}
            closeModal={handleCloseModalClose}
            refetchCustomer={refetchCustomer}
          />
        )}
      </Modal>
    </div>
  );
}
